import * as React from "react";
export const HeaderContainer = (props) => {
    return (React.createElement("div", { style: headerContainerStyle }, props.children));
};
export const BodyContainer = (props) => {
    return (React.createElement("div", { style: { ...bodyContainerStyle, ...props.style } }, props.children));
};
const headerContainerStyle = {
    margin: 24
};
const bodyContainerStyle = {
    borderRadius: 12,
    margin: 24,
};
